
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aktualnosci",
      function () {
        return require("private-next-pages/aktualnosci/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aktualnosci"])
      });
    }
  